import { PageInfo, QueryVariablesTypes, TextMaterial } from '@@types'
import { gql, useQuery } from '@apollo/client'

import { SHORTCUT_TEXT_MATERIAL } from '../fragments'


interface AllTextMaterialsQuery {
  allTextMaterials: {
    edges: TextMaterial[]
    pageInfo: PageInfo
  }
}

export const GQL_QUERY_ALL_TEXT_MATERIALS = gql`
  query allTextMaterials (
    $filter: NestedFilterInput,
    $pager: CommonPagerInput,
    $sort: CommonSortInput
  ) {
    allTextMaterials(filter: $filter, pager: $pager, sort: $sort) {
      edges {
        ${SHORTCUT_TEXT_MATERIAL}
      }
      pageInfo {
        page
        perPage
        lastPage
        next
        total
      }
    }
  }
`

export const useFetchAllTextMaterials = (variables: QueryVariablesTypes) => {
  const { data, loading, error, refetch } = useQuery<AllTextMaterialsQuery, QueryVariablesTypes>(
    GQL_QUERY_ALL_TEXT_MATERIALS,
    {
      variables,
      fetchPolicy: 'cache-and-network'
    }
  )

  const textMaterials = data?.allTextMaterials?.edges ?? []
  const pageInfo = data?.allTextMaterials?.pageInfo

  return {
    textMaterials,
    pageInfo,
    data,
    loading,
    error,
    refetch
  }
}